export default __webpack_public_path__ + "images/ef760a6034133c489f7e21f83e7d7c2a-Eventbrite_Halloween_HomepageB_1067x312.webp";